import { FC } from "react";

import { DesignToken, Link, Text } from "@livechat/design-system-react-components";

import { HelpCenter } from "constants/help-center";
import { withVar } from "themes/helpers";

import { trackLearnMoreClicked } from "./analytics";

export const Headline: FC = () => {
  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  const trackLearnMore = () => {
    trackLearnMoreClicked();
  };

  return (
    <Text customColor={withVar(DesignToken.ContentBasicSecondary)}>
      Set the display name and email address that customers will actually see when you reply to their tickets.{" "}
      <Link href={HelpCenter.REPLY_ADDRESSES} bold={false} target="_blank" onClick={trackLearnMore}>
        Learn more
      </Link>
    </Text>
  );
};
